var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 2C0.5 1.17157 1.17157 0.5 2 0.5H18C18.8284 0.5 19.5 1.17157 19.5 2V18C19.5 18.8284 18.8284 19.5 18 19.5H2C1.17157 19.5 0.5 18.8284 0.5 18V2Z",
    stroke: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6004 16.0888H11.0345V9.99317H12.7328L12.9141 7.95218H11.0345C11.0345 7.95218 11.0345 7.19023 11.0345 6.78981C11.0345 6.30846 11.1311 6.11824 11.5967 6.11824C11.9709 6.11824 12.9141 6.11824 12.9141 6.11824V4C12.9141 4 11.5253 4 11.2284 4C9.41701 4 8.6004 4.79769 8.6004 6.32475C8.6004 7.65476 8.6004 7.95218 8.6004 7.95218H7.33398V10.0189H8.6004V16.0888Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.0d8a56dd8c45110b93206a3036028842.svg";
export { ForwardRef as ReactComponent };